import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'xdh-map/lib/xdhmap.css';
import 'vuescroll/dist/vuescroll.css';
import posIcon from '@/assets/others/map/location.png';
import { XdhMap, XdhMapDraw, XdhMapPlacement, XdhMapPolygon, XdhMapLine, XdhMapImage, XdhMapText } from 'xdh-map';
import VueScroll from 'vuescroll/dist/vuescroll-slide';
var cacheKey = '__draw_feature__';
export default {
  name: 'MapGetGrid',
  components: {
    XdhMap: XdhMap,
    XdhMapDraw: XdhMapDraw,
    XdhMapPlacement: XdhMapPlacement,
    XdhMapPolygon: XdhMapPolygon,
    XdhMapLine: XdhMapLine,
    XdhMapImage: XdhMapImage,
    XdhMapText: XdhMapText,
    VueScroll: VueScroll
  },
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      if (!_this.checkFull()) {
        // 退出全屏后要执行的动作
        console.log("退出全屏");

        _this.exitfullscreen();
      }
    };

    this.mapCenter = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];
    this.$nextTick(function () {
      setTimeout(function () {
        _this.drawBounds();
      }, 500);
    });
  },
  data: function data() {
    return {
      coordsys: 'autonavi',
      showText: [],
      mapPadding: '0px',
      mapHeight: '500px',
      isFullscreen: false,
      posIcon: posIcon,
      district: null,
      searchValue: '',
      // state: yaan,
      line: [],
      visible: false,
      mapCenter: [118.047928, 24.613341],
      title: '',
      coordinate: '',
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      searchurl: 'https://restapi.amap.com/v3/config/district?key=44641f38739649861c9d7d31f69b4ac2',
      maptype: 'Amap2',
      mode: 'finish',
      mapDrawType: '1',
      polygonData: [],
      fill: 'rgba(0, 0, 0, 0.5)',
      detailData: [],
      siteList: []
    };
  },
  methods: {
    checkFull: function checkFull() {
      //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
      //火狐浏览器
      var isFull = document.mozFullScreen || document.fullScreen || //谷歌浏览器及Webkit内核浏览器
      document.webkitIsFullScreen || document.webkitRequestFullScreen || document.mozRequestFullScreen || document.msFullscreenEnabled;

      if (isFull === undefined) {
        isFull = false;
      }

      return isFull;
    },
    fullscreenSubmit: function fullscreenSubmit() {
      this.exitfullscreen();
      this.handleOk();
    },
    fullscreenClose: function fullscreenClose() {
      this.exitfullscreen();
      this.handleCancel();
    },
    fullscreen: function fullscreen(index) {
      var docElm = document.getElementById('mapBox' + index); // 指定容器id
      //W3C

      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } //IE11
      else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }

      if (index == 1) {
        this.mapReady('');
        this.mapHeight = '830px';
      } else if (index == 2) {
        this.mapReady('2');
        this.mapHeight = '885px';
      } else if (index == 3) {
        this.mapReady('3');
        this.mapHeight = '980px';
      }

      this.mapPadding = '20px';
      this.isFullscreen = true;
    },
    //退出全屏
    exitfullscreen: function exitfullscreen() {
      this.isFullscreen = false;

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }

      this.mapHeight = '500px';
      this.mapPadding = '0px';
    },
    handleImageClick: function handleImageClick(index) {
      this.showText[index] = !this.showText[index];
      this.$forceUpdate();
    },
    drawBounds: function drawBounds() {
      var that = this;
      AMap.plugin(['AMap.DistrictSearch'], function () {
        //加载行政区划插件
        if (!that.district) {
          //实例化DistrictSearch
          var opts = {
            subdistrict: 0,
            //获取边界不需要返回下级行政区
            extensions: 'all',
            //返回行政区边界坐标组等具体信息
            level: 'city' //查询行政级别为 市

          };
          that.district = new AMap.DistrictSearch(opts);
        }
      });
    },
    searchMapData: function searchMapData() {
      var _this2 = this;

      this.district.search(this.searchValue, function (status, result) {
        var bounds = result.districtList[0].boundaries;
        var location = [result.districtList[0].center.lng, result.districtList[0].center.lat];

        _this2.$refs.myMap2.moveTo(location);

        if (bounds) {
          _this2.polygonData = bounds.map(function (item) {
            return item.map(function (info) {
              return [info.lng, info.lat];
            });
          });
        }
      });
    },
    changeMap: function changeMap(e) {
      this.maptype = e.target.value;

      if (e.target.value == 'Amap') {
        this.$refs.myMap.changeType(e.target.value);
      } else {
        this.$refs.myMap.changeType('Amap2');
      }
    },
    changeCoordsys: function changeCoordsys() {
      var _this3 = this;

      if (this.coordinate && this.coordinate.indexOf(':') != -1) {
        var point = this.coordinate.split(':');
        this.$jsonp("https://restapi.amap.com/v3/assistant/coordinate/convert?key=44641f38739649861c9d7d31f69b4ac2&coordsys=".concat(this.coordsys, "&locations=").concat(point[0], ",").concat(point[1])).then(function (res) {
          if (res.info == 'ok') {
            _this3.mapCenter = res.locations.split(',');

            _this3.$refs.myMap.moveTo(res.locations.split(','));
          }
        });
      } else {
        this.$message_custom("请使用冒号（:）分隔经纬度", 'warn');
      }
    },
    show: function show(type, parmCenter, pointLists, siteList, searchValue) {
      var _this4 = this;

      this.siteList = siteList ? siteList : [];
      this.siteList = _toConsumableArray(this.siteList).map(function (item) {
        item.siteCoordinate = item.siteCoordinate.split(',');
        return _objectSpread({}, item);
      });
      this.mapDrawType = type;

      if (pointLists) {
        this.searchValue = '';

        if (type == 0) {
          var pointList = pointLists.features.split(':');
          this.detailData = pointList.map(function (v) {
            return v.split('-').map(function (item) {
              return item.split(',');
            });
          });
        } else if (type == 1) {
          setTimeout(function () {
            if (pointLists.geoJson) {
              _this4.$refs.draw.fromJSON(pointLists.geoJson);
            }

            _this4.modify();
          }, 500);
        } else if (type == 2) {
          console.log('show', pointLists.features);
          var pointList = pointLists.features.split(':');
          this.polygonData = pointList.map(function (v) {
            return v.split('-').map(function (item) {
              return item.split(',');
            });
          });
        }
      } else {
        this.detailData = [];
        this.polygonData = [];

        if (searchValue) {
          this.searchValue = searchValue;
          setTimeout(function () {
            _this4.searchMapData();
          }, 1000);
        }
      }

      if (parmCenter && parmCenter[0] && parmCenter[1]) {
        this.mapCenter = parmCenter;
        this.coordinate = '';
      }

      if (this.coordinate && this.coordinate.indexOf(':') != -1) {
        this.mapCenter = this.coordinate.split(':');

        switch (type) {
          case 0:
            this.$refs.myMap3.moveTo(this.coordinate.split(':'));
            break;

          case 1:
            this.$refs.myMap.moveTo(this.coordinate.split(':'));
            break;

          case 2:
            this.$refs.myMap2.moveTo(this.coordinate.split(':'));
            break;
        }
      }

      this.visible = true;
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;

      if (this.mapDrawType == '0') {
        this.mapReady('3');
      } else if (this.mapDrawType == '1') {
        this.mapReady('');
      } else if (this.mapDrawType == '2') {
        this.mapReady('2');
      }
    },
    handleOk: function handleOk() {
      if (this.mapDrawType == 1) {
        var features = this.$refs.draw.getFeatures().map(function (item) {
          return item.map(function (info) {
            return info.split(',');
          });
        });
        this.$emit('mapChange', {
          features: features,
          geoJson: this.$refs.draw.toJSON()
        });
      } else if (this.mapDrawType == 2) {
        console.log('handleOk', this.polygonData);
        this.$emit('mapChange', {
          features: this.polygonData,
          geoJson: ''
        });
      }

      this.handleCancel();
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    searchMap: function searchMap() {
      var _this5 = this;

      if (this.title) {
        //可用filter限制搜索区域,限制参数填入adcode
        // const surl=this.searchurl+"&filter=511800&keywords="+this.title
        var surl = this.searchurl + '&keywords=' + this.title;

        var _that = this;

        this.$jsonp(surl).then(function (res) {
          if (res && res.districts && res.districts.length > 0) {
            var location = res.districts[0].center.split(',');

            _this5.$refs.myMap.moveTo(location);
          } else {
            _that.$message.warning('未查询到对应数据!');
          }
        });
      } else {
        that.$message.warning('请输入需要搜索的关键字');
      }
    },
    mapReady: function mapReady(index) {
      this.$refs['myMap' + index].resize();
      this.$refs['myMap' + index].moveTo(this.mapCenter);
    },
    draw: function draw() {
      this.$refs.draw.finish();
      this.$refs.draw.draw();
      this.mode = 'draw';
    },
    modify: function modify() {
      this.$refs.draw.finish();
      this.$refs.draw.modify();
      this.mode = 'modify';
    },
    finish: function finish() {
      this.$refs.draw.finish();
      this.mode = 'finish';
    },
    clear: function clear() {
      this.$refs.draw.clear();
    }
  }
};